/**
 * Homepage cart loader.
 *
 * Contract:
 * - Visibility stays on Alpine x-show in cart-drawer.liquid.
 * - Desktop layout (960 / 7-12) stays on Liquid + CSS, not this file.
 * - This file only loads satellite scripts and hydrates #CartDrawer.
 * - First appear and cart section refresh (innerHTML swap) both re-init new markup.
 * - Satellites do not block the first open.
 * - Mobile-only: if the drawer never appears, fall back to /cart.
 */
(function () {
  var urls = window.amcIntentScriptUrls;
  if (!urls || !urls.length) return;

  var ISLAND_SEL =
    '[x-data^="xCartFields"],[x-data^="xCouponCode"],[x-data="xCartTerm"],[x-data^="xCartTerm("],[x-data^="xCartCountdownTimer"]';

  var satellitesStarted = false;
  var satellitesReady = false;
  var satellitesPrefetched = false;
  var fallbackTimer = null;
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);

  function shouldSkipWarm() {
    var conn = navigator.connection;
    if (!conn) return false;
    return !!(conn.saveData || conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g');
  }

  function cartHref() {
    var icon = document.getElementById('cart-icon');
    if (icon && icon.getAttribute('href')) return icon.getAttribute('href');
    return '/cart';
  }

  function isCartIntent(el) {
    return !!(el && el.closest && el.closest('#cart-icon, [data-amc-header-cart], #CartDrawer, a[href*="/cart"]'));
  }

  function isHeaderCart(el) {
    return !!(el && el.closest && el.closest('#cart-icon, [data-amc-header-cart]'));
  }

  function isAddToCart(el) {
    return !!(
      el &&
      el.closest &&
      el.closest('[name="add"], form[data-type="add-to-cart-form"], [data-amc-add-to-cart]')
    );
  }

  function whenAlpine(fn) {
    if (window.amcWhenAlpine) {
      window.amcWhenAlpine(function () {
        queueMicrotask(fn);
      });
      return;
    }
    if (window.Alpine) {
      queueMicrotask(fn);
      return;
    }
    document.addEventListener('alpine:init', function () {
      queueMicrotask(fn);
    });
  }

  function hasStore(name) {
    try {
      return !!(window.Alpine && Alpine.store && Alpine.store(name));
    } catch (err) {
      return false;
    }
  }

  function stubStore(name, value) {
    if (!window.Alpine || typeof Alpine.store !== 'function' || hasStore(name)) return;
    Alpine.store(name, value);
  }

  function ensureStores() {
    stubStore('xCartShare', {
      shared: false,
      openShareCart: false,
      cartShareUrl: '',
      handleShareCart: function () {},
      generateUrl: function () {},
    });
    stubStore('xCouponCodeDetail', {
      loading: false,
      discountFaild: false,
      freeShippingApplied: false,
      discountApplied: false,
      discountCorrect: false,
      removedDiscountCode: '',
      appliedDiscountCodes: [],
      removeDiscountCode: function () {},
      clearRemovedDiscount: function () {},
      getDiscountCode: function () {},
    });
    stubStore('xPopupInsurance', {
      open: false,
      openInsuranceNoti: false,
      loading: false,
      openInsuranceNotification: function () {},
    });
    stubStore('xPopupShipping', { open: false });
    stubStore('xProductRecommendations', { loadUpsell: function () {} });
  }

  function isolateIslands(root) {
    Array.prototype.forEach.call(root.querySelectorAll(ISLAND_SEL), function (el) {
      if (el.hasAttribute('x-ignore')) return;
      el.setAttribute('x-ignore', '');
      el.setAttribute('data-amc-cart-island', '1');
    });
  }

  function revealIslands(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-amc-cart-island]'), function (el) {
      el.removeAttribute('x-ignore');
      el.removeAttribute('data-amc-cart-island');
    });
  }

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  function isDrawerShowing() {
    if (window.Alpine && Alpine.store('xMiniCart') && !Alpine.store('xMiniCart').open) {
      return false;
    }
    return isVisible(document.getElementById('update-cart')) || isVisible(document.getElementById('CartDrawer-Overlay'));
  }

  function panelNeedsHydrate(root) {
    var panel = root.querySelector('#update-cart');
    return !panel || !panel._x_dataStack;
  }

  function hydrateIslands(root) {
    if (!satellitesReady) return;
    revealIslands(root);
    Array.prototype.forEach.call(root.querySelectorAll(ISLAND_SEL), function (island) {
      if (island._x_dataStack) return;
      island.removeAttribute('x-ignore');
      Alpine.initTree(island);
    });
  }

  function tryHydrate() {
    var el = document.getElementById('CartDrawer');
    if (!el || !window.Alpine || typeof Alpine.initTree !== 'function') return;

    ensureStores();

    if (panelNeedsHydrate(el)) {
      if (!satellitesReady) isolateIslands(el);
      el.removeAttribute('x-ignore');
      Alpine.initTree(el);
      el.setAttribute('data-amc-cart-hydrated', '1');
    }

    hydrateIslands(el);
  }

  function loadScript(src) {
    return new Promise(function (resolve) {
      var safeSrc = src.replace(/"/g, '');
      var existing = document.querySelector('script[src="' + safeSrc + '"]');
      if (existing) {
        existing.dataset.amcIntentLoaded = '1';
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.dataset.amcIntentLoaded = '1';
      script.onload = resolve;
      script.onerror = resolve;
      document.body.appendChild(script);
    });
  }

  function prefetchSatellites() {
    if (satellitesPrefetched || satellitesStarted || shouldSkipWarm()) return;
    satellitesPrefetched = true;
    urls.forEach(function (src) {
      var href = src.replace(/"/g, '');
      if (document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'script';
      link.href = src;
      document.head.appendChild(link);
    });
  }

  function startSatellites() {
    if (satellitesStarted) return;
    satellitesStarted = true;
    Promise.all(urls.map(loadScript)).then(function () {
      satellitesReady = true;
      whenAlpine(tryHydrate);
    });
  }

  function watchDrawer() {
    var bound = null;
    var childObs = null;
    var parentObs = null;
    var boot = null;

    function bind(el) {
      if (bound === el) {
        whenAlpine(tryHydrate);
        return;
      }
      bound = el;
      if (childObs) childObs.disconnect();
      if (parentObs) parentObs.disconnect();
      if (boot) {
        boot.disconnect();
        boot = null;
      }
      if ('MutationObserver' in window) {
        childObs = new MutationObserver(function () {
          whenAlpine(tryHydrate);
        });
        childObs.observe(el, { childList: true });
        if (el.parentNode) {
          parentObs = new MutationObserver(function () {
            var next = document.getElementById('CartDrawer');
            if (next && next !== bound) bind(next);
          });
          parentObs.observe(el.parentNode, { childList: true });
        }
      }
      whenAlpine(tryHydrate);
    }

    var existing = document.getElementById('CartDrawer');
    if (existing) {
      bind(existing);
      return;
    }
    if (!('MutationObserver' in window)) return;

    boot = new MutationObserver(function () {
      var el = document.getElementById('CartDrawer');
      if (el) bind(el);
    });
    boot.observe(document.documentElement, { childList: true, subtree: true });
  }

  function clearFallback() {
    if (!fallbackTimer) return;
    window.clearTimeout(fallbackTimer);
    fallbackTimer = null;
  }

  function armFallback() {
    if (canHover || fallbackTimer) return;
    var started = Date.now();
    fallbackTimer = window.setTimeout(function () {
      fallbackTimer = null;
      if (isDrawerShowing()) return;
      whenAlpine(function () {
        tryHydrate();
        if (hasStore('xMiniCart') && typeof Alpine.store('xMiniCart').openCart === 'function') {
          Alpine.store('xMiniCart').openCart();
        }
      });
    }, 1800);

    function tick() {
      if (!fallbackTimer) return;
      if (isDrawerShowing()) {
        clearFallback();
        return;
      }
      if (Date.now() - started > 1800) return;
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }

  function bindCartTriggers() {
    document.addEventListener(
      'pointerdown',
      function (e) {
        if (isAddToCart(e.target)) startSatellites();
        if (!isCartIntent(e.target)) return;
        startSatellites();
        if (isHeaderCart(e.target)) armFallback();
      },
      true
    );
    document.addEventListener('focusin', function (e) {
      if (isCartIntent(e.target)) startSatellites();
    });
    // Adding to cart opens the drawer without ever touching a cart intent
    // target, so the satellites have to start on the cart change itself.
    document.addEventListener('eurus:cart:items-changed', startSatellites);

    if (!canHover) return;

    Array.prototype.forEach.call(
      document.querySelectorAll('#cart-icon, [data-amc-header-cart]'),
      function (el) {
        el.addEventListener('pointerenter', startSatellites, { passive: true });
      }
    );
  }

  bindCartTriggers();
  watchDrawer();

  if (window.location.search.indexOf('share_cart:true') !== -1 || (window.Shopify && Shopify.designMode)) {
    startSatellites();
  }

  if (window.Shopify && Shopify.designMode) return;

  function idleStart() {
    var warm = function () {
      prefetchSatellites();
    };
    if (window.requestIdleCallback) {
      requestIdleCallback(warm, { timeout: 8000 });
    } else {
      setTimeout(warm, 4000);
    }
  }

  if (document.readyState === 'complete') {
    idleStart();
  } else {
    window.addEventListener('load', idleStart);
  }
})();
